import { APP_START } from '../../constants';
import { WINDOW_VIEWS } from './StateAndProps';


export const TYPES = {
    DATA_LOADED: APP_START | 0x00001,
    SET_GRAPH: 'SET_GRAPH',
    SET_FILTER: 'SET_FILTER',
    SET_SECOND_FILTER: 'SET_SECOND_FILTER'
};

export const ACTIONS = {
    DATA_LOADED: function (a: any) {
        return {
            type: TYPES.DATA_LOADED,
            data: a
        };
    },
    SET_GRAPH:(data)=>{
        return {
            type:TYPES.SET_GRAPH, 
            data
        }
    },

    SET_FILTER:(data)=>{
        return {
            type:TYPES.SET_FILTER, 
            data
        }
    },

    SET_SECOND_FILTER:(data)=>{
        return {
            type:TYPES.SET_SECOND_FILTER, 
            data
        }
    }
}